import { useMutation } from 'react-query';
import { message } from 'antd';
import request from '../../helpers/request';

const errorMessage = 'При удалении комментария произошла ошибка';

const mutationFn = ({ addressId, commentId }) => {
  return request.delete(
    `/HousingStock/address/${addressId}/comment_v2?commentId=${commentId}`,
    undefined,
    errorMessage,
    'Error'
  );
};

const useDeleteFlatComment = (options) => {
  return useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data === 'Error') {
        return;
      }

      if (data.success === false) {
        message.error(data.message || errorMessage);
        return;
      }

      if (typeof options?.onSuccess === 'function') {
        options.onSuccess(data, variables);
      }
    },
  });
};

export default useDeleteFlatComment;
